import tinyColor from "tinycolor2";

export function compose(color, ...transformers) {
    return transformers
        .reduce((result, transformer) => result['__stopTransform__'] ? result : transformer(result), tinyColor(color))
        .toRgbString();
}

/** *************************************************
 * Transformers
 *
 * To be used with the compose function above
 * to transform a color
 *
 * *********************************************** **/

/**
 * Change Opacity
 *
 * @param alpha {number} accepted range 0-1
 * @returns {function(*): *}
 */
export function setAlpha(alpha) {
    return (color) => color.setAlpha(alpha);
}

/**
 * Darken color if light and lighten if dark
 *
 * @param amount {number} accepted range 0-100
 * @returns {Function}
 */
export function emphasize(amount) {
    return (color) => {
        if (color.isLight())
            return color.darken(amount);
        else
            return color.lighten(amount);
    }
}

/**
 * To use specially when you want a color in top of another color, with the first one emphasized
 *
 * @param secondColor {string} any type of color (hex, rgb..)
 * @param amount {number} accepted range 0-100
 * @returns {Function}
 */
export function emphasizeAgainst(secondColor, amount) {
    return (color) => {
        const secondTinyColor = tinyColor(secondColor);
        const luminanceDiff = secondTinyColor.getLuminance() - color.getLuminance();

        // Return as is if already emphasized
        if (Math.abs(luminanceDiff) >= (amount / 100))
            return color;

        const bothLight = color.isLight() && secondTinyColor.isLight();
        const bothDark = color.isDark() && secondTinyColor.isDark();
        const secondIsDarker = luminanceDiff < 0;

        if (bothLight || !secondIsDarker)
            color.darken(amount);
        else if (bothDark || secondIsDarker)
            color.lighten(amount);

        return color;
    };
}

/**
 * Act as a middleware to stop transformation if the result
 * color become equal to the given color.
 *
 * @param searchColor {string} any type of color (hex, rgb..)
 * @returns {function(*=): *}
 */

export function ignoreWhenColorIs(searchColor) {
    return (color) => {
        if (tinyColor.equals(color, searchColor))
            color['__stopTransform__'] = true;
        return color;
    }
}